import { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const ShortLinkRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Change the URL to /post/:id without reloading
    navigate(`/post/${id}`, { replace: true, state: { fromShort: true, ...location.state } });
  }, [id, navigate, location.state]);

  return null; // Or show a loading spinner if you want
};

export default ShortLinkRedirect;